import { Edit, Trash2 } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import HeaderModule from "../../components/Header/HeaderModule";
import { useCheckUserPermission } from "../../common/userPermission";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
// import axios from "axios"
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";

const notificationDelete = "notificationDelete";

const NotificationList = () => {
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [deletes, setdelete] = useState(false);
  const [opnePopUp, setOpnePopUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [section, setSection] = useState("");
  const MySwal = withReactContent(Swal);
  const usetData = useSelector((state) => state.user_data);
  const BusinessID = usetData?.businessId;
  const [remainingEmailQuota, setRemainingEmailQuota] = useState(0);
  const [remainingSmsQuota, setRemainingSmsQuota] = useState(0);
  const [remainingWhatsAppQuota, setRemainingWhatsAppQuota] = useState(0);

  console.log(remainingEmailQuota, "check remainingEmailQuota");
  console.log(remainingSmsQuota, "check remainingEmailQuota");
  console.log(remainingWhatsAppQuota, "check remainingEmailQuota");
  const showConfirmationAlert = (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };

  console.log(selectedCustomers, "check selectedCustomers");

  useEffect(() => {
    const fetchAppointmentData = async () => {
      const response = await apiHandler({
        method: "GET",
        route: `Business/customerlist?businessId=${usetData?.businessId}`,
      });

      if (response?.ResponseCode === "SUCCESS") {
        const customerData = response?.ResponseData || [];
        const mappedCustomers = customerData.map((el) => ({
          label: el.firstName,
          value: el.id,
          email: el.email,
          phoneNumber: el.phoneNumber,
        }));
        setCustomers(mappedCustomers);
      } else {
        console.error("Failed to fetch customers", response);
      }
    };

    if (usetData?.businessId) {
      fetchAppointmentData();
    }
  }, [usetData?.businessId]);

  const handleOpnePopup = (from, data) => {
    setOpnePopUp(true);
    setData(data);
    setSection(from);
  };

  const handleClosePopup = () => {
    setOpnePopUp(false);
    setSection("");
    setData("");
  };

  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "notificationMaster",
    };

    try {
      const response = await apiHandler({
        method: "POST",
        route: "Superadmin/deletebymoduleid",
        payload: reqobj,
      });

      if (response.ResponseCode === "SUCCESS") {
        MySwal.fire({
          title: "Deleted!",
          text: "Your notification has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        setdelete(!deletes);
      } else {
        MySwal.fire({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      MySwal.fire({
        title: "Error!",
        text: "An error occurred. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      enableSorting: true,
      sortingFn: "numeric",
      size: 100,
    },
    {
      header: "Unique Name",
      accessorKey: "notificationUniqueName",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 600,
      Cell: ({ row }) => (
        <span title={row.original.notificationUniqueName}>
          {row.original.notificationUniqueName}
        </span>
      ),
    },
    {
      header: "Email Subject",
      accessorKey: "emailSubject",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 300,
      Cell: ({ row }) => (
        <span title={row.original.emailSubject}>
          {row.original.emailSubject}
        </span>
      ),
    },
    {
      header: "Email CC",
      accessorKey: "emailCC",
      enableSorting: true,
      sortingFn: "alphanumeric",
      Cell: ({ row }) => (
        <span title={row.original.emailCC}>{row.original.emailCC}</span>
      ),
    },
    {
      header: "Email Active",
      accessorKey: "emailIsActive",
      Cell: ({ row }) => (
        <span
          className={
            row.original.emailIsActive
              ? "btn btn-primary btn-sm me-2"
              : "btn btn-outline-primary btn-sm me-2"
          }
        >
          {row.original.emailIsActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      header: "SMS Active",
      accessorKey: "smsIsActive",
      Cell: ({ row }) => (
        <span
          className={
            row.original.smsIsActive
              ? "btn btn-primary btn-sm me-2"
              : "btn btn-outline-primary btn-sm me-2"
          }
        >
          {row.original.smsIsActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      header: "WhatsApp Active",
      accessorKey: "whatsappIsActive",
      Cell: ({ row }) => (
        <span
          className={
            row.original.whatsappIsActive
              ? "btn btn-primary btn-sm me-2"
              : "btn btn-outline-primary btn-sm me-2"
          }
        >
          {row.original.whatsappIsActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      size: BusinessID > 0 ? 500 : 220,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          {useCheckUserPermission(route.notificationMaster) && (
            <button
              className="btn btn-outline-primary btn-sm me-2"
              onClick={() => {
                navigate(`${route.notificationMaster}/${row.original.id}`);
              }}
            >
              <Edit className="custome-icon-size" />
            </button>
          )}
          {useCheckUserPermission(notificationDelete) && (
            <button
              className="btn btn-outline-primary btn-sm me-2"
              onClick={() => {
                showConfirmationAlert(row.original.id);
              }}
            >
              <Trash2 className="custome-icon-size" />
            </button>
          )}
          {row.original.id === 33 &&
            row.original.notificationUniqueName === "Marketing_Booster" && (
              <button
                className="btn btn-outline-primary btn-sm me-2"
                onClick={() => {
                  navigate(
                    `${route.notificationMaster}/${row.original.id}?clone=true`
                  );
                }}
              >
                Clone
              </button>
            )}
          {row.original.notificationUniqueName !== "Marketing_Booster" &&
            BusinessID !== 0 && (
              <button
                className="btn btn-primary btn-sm btn-wave me-2"
                onClick={() =>
                  handleOpnePopup("Send Email", row.original.emailBody)
                }
              >
                Send Email
              </button>
            )}
          {row.original.notificationUniqueName !== "Marketing_Booster" &&
            BusinessID !== 0 && (
              <button
                className="btn btn-primary btn-sm btn-wave me-2"
                onClick={() =>
                  handleOpnePopup("Send SMS", row.original.smsBody)
                }
              >
                Send SMS
              </button>
            )}
          {row.original.notificationUniqueName !== "Marketing_Booster" &&
            BusinessID !== 0 && (
              <button
                className="btn btn-primary btn-sm btn-wave me-2"
                onClick={() =>
                  handleOpnePopup(
                    "Send WhatsApp Massage",
                    row.original.whatsappBody
                  )
                }
              >
                WhatsApp Massage
              </button>
            )}
        </Box>
      ),
    },
  ];

  const route = all_routes;

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/notificationMasterAll`,
      payload: { ID: BusinessID },
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  const exportData = productlist.map((item) => ({
    ID: item?.id,
    Name: item?.zipCode,
    isActive: item?.isActive == 1 ? "Active" : "InActive",
  }));

  const handleSend = async () => {
    if (!selectedCustomers.length) {
      alert("Please select at least one customer.");
      return;
    }

    setLoading(true);
    try {
      // Prepare email list and content
      let payload;
      let routeName = `Business/sendEmail`;

      if (section === "Send SMS") {
        payload = {
          recipients: selectedCustomers.map((c) => ({
            name: c.name,
            phoneNumber: c.phoneNumber,
            CustID: c.id,
          })),
          body: data, // this is your SMS content
          section: "SMS",
          BusinessID: BusinessID,
        };
        routeName = `Business/sendEmail`;
        console.log(payload, "check this payload");
      } else {
        payload = {
          recipients: selectedCustomers.map((c) => ({
            name: c.name,
            email: c.email,
            CustID: c.id,
          })),
          subject: "Your Business Notification", // you can replace this dynamically
          body: data, // this is your email HTML content
          section: "Email",
          BusinessID: BusinessID,
        };
      }

      console.log(payload, "check this payload");

      const response = await apiHandler({
        method: "POST",
        route: routeName,
        payload,
      });

      if (response.ResponseCode === "SUCCESS") {
        // alert("Emails sent successfully!");
        getBusinessDetailById(BusinessID);
        setSelectedCustomers([]);
        handleClosePopup();
        setLoading(false);
      } else if (response.ResponseCode === "ERROR") {
        MySwal.fire({
          title: "Error!",
          text: response.ResponseMessage || "An error occurred",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Send email error:", error);
      alert("Error sending emails.");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectChange = (selectedOptions) => {
    const selected = selectedOptions
      ? selectedOptions.map((opt) => ({
        id: opt.value,
        name: opt.label,
        email: opt.email,
        phoneNumber: opt.phoneNumber,
      }))
      : [];

    const normalizedSection = (section || "").toLowerCase();

    let remainingQuota = 0;
    let quotaLabel = "quota";
    if (normalizedSection.includes("email")) {
      remainingQuota = remainingEmailQuota;
      quotaLabel = "Email";
    } else if (normalizedSection.includes("sms")) {
      remainingQuota = remainingSmsQuota;
      quotaLabel = "SMS";
    } else if (
      normalizedSection.includes("whats") ||
      normalizedSection.includes("whatsapp")
    ) {
      remainingQuota = remainingWhatsAppQuota;
      quotaLabel = "WhatsApp";
    }

    if (remainingQuota === 0 && selected.length > 0) {
      alert(`You have no remaining ${quotaLabel} quota.`);
      return;
    }

    if (selected.length > remainingQuota) {
      alert(
        `You can only select ${remainingQuota} customer(s) based on your remaining ${quotaLabel} quota.`
      );
      return;
    }

    setSelectedCustomers(selected);
  };

  const handlepull = () => {

    setSelectedCustomers(customers.map((c) => ({
      id: c.value,
      name: c.label,
      email: c.email,
      phoneNumber: c.phoneNumber,
    }))

    )
  }

  const normalizedSection = (section || "").toLowerCase();

  const getBusinessDetailById = async (bId) => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/getRemainQuota?businessId=${bId || 0}`,
    });

    if (response.ResponseCode === "SUCCESS") {
      const data = response.ResponseData;

      const totalEmail = data[0]?.[0]?.emailCount || 0;
      const totalSMS = data[0]?.[0]?.smsCount || 0;
      const totalWhatsApp = data[0]?.[0]?.whatsAppCount || 0;

      const usedEmail = data[1]?.[0]?.mailCounter || 0;
      const usedSMS = data[1]?.[0]?.smsCounter || 0;
      const usedWhatsApp = data[1]?.[0]?.whatsAppCounter || 0;

      const remainingEmail = Math.max(totalEmail - usedEmail, 0);
      const remainingSMS = Math.max(totalSMS - usedSMS, 0);
      const remainingWhatsApp = Math.max(totalWhatsApp - usedWhatsApp, 0);

      setRemainingEmailQuota(remainingEmail);
      setRemainingSmsQuota(remainingSMS);
      setRemainingWhatsAppQuota(remainingWhatsApp);

      console.log("Remaining Quotas:", {
        Email: remainingEmail,
        SMS: remainingSMS,
        WhatsApp: remainingWhatsApp,
      });
    }
  };

  useEffect(() => {
    getBusinessDetailById(BusinessID);
  }, [BusinessID]);

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <Modal show={opnePopUp} onHide={handleClosePopup} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{section}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <div>
              <p className="text-sm text-gray-600 mb-2">
                {normalizedSection.includes("email") ? (
                  <>
                    Remaining Email Quota:{" "}
                    <strong>{remainingEmailQuota ?? "—"}</strong>
                  </>
                ) : normalizedSection.includes("sms") ? (
                  <>
                    Remaining SMS Quota:{" "}
                    <strong>{remainingSmsQuota ?? "—"}</strong>
                  </>
                ) : normalizedSection.includes("whats") ? (
                  <>
                    Remaining WhatsApp Quota:{" "}
                    <strong>{remainingWhatsAppQuota ?? "—"}</strong>
                  </>
                ) : (
                  <span className="text-red-500">
                    Unknown section: {String(section)}
                  </span>
                )}
              </p>
              <div className="row">
                <div className="col-10 mb-3">

                  <Select
                    className="img-select"
                    classNamePrefix="react-select"
                    options={customers}
                    value={customers.filter((cust) =>
                      selectedCustomers.some((sel) => sel.id === cust.value)
                    )}
                    onChange={handleSelectChange}
                    placeholder={`Select Customers You Want To Send ${section}`}
                    isMulti
                  />
                </div>
                <div className="col-2 mb-3 d-flex align-items-center">

                  <button className="btn btn-primary" onClick={() => handlepull()}>
                    Pull
                  </button>
                </div>
              </div>
            </div>
          </div>
          {section === "Send Email" ? (
            <div
              className="email-preview"
              dangerouslySetInnerHTML={{ __html: data }}
            />
          ) : (
            <pre
              style={{
                background: "#f8f9fa",
                padding: "15px",
                borderRadius: "8px",
                whiteSpace: "pre-wrap",
              }}
            >
              {data}
            </pre>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClosePopup}>
            Close
          </Button>
          <Button onClick={() => handleSend()} variant="primary">
            Send Now
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="page-wrapper">
        <div className="content">
          <HeaderModule
            refreshData={prodcutDataListApi}
            exportData={exportData}
            addMasterPageLink={route.notificationMaster}
          />
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-responsive">
                <CommonMaterialReactTable
                  columns={columns}
                  data={productlist}
                  columnRightPin={["actions"]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationList;
